import {useState,useEffect,useContext} from 'react'
import AuthContext from '../../AuthContext'
import axios from '../../axios'
const BatchDropdown = ({value,handleInputChange,dont, centre, imp}) => {
    const [batch, setBatch] = useState([]);
    const [err,setErr]=useState(false)
  const auth=useContext(AuthContext)
    useEffect(() => {
      const fetchBatches = async () => {
        try {
          const centreId = auth.userType === 'Admin' ? auth.centre : centre;
          const response = await axios.get('/batch/getIdName',{
            params:{
              centre_id:centreId
            }
          }); // Replace '/api/batchs' with your actual API endpoint
          setBatch(response.data.batch);
        } catch (error) {
          console.error('Error fetching batches:', error);
          setErr(true)
        }
      };
  
      fetchBatches();
    }, [centre,auth.centre,auth.userType]);
  
    return (
      <div className="flex flex-col">
        <label htmlFor='batch'className="block mb-2 text-sm font-medium text-gray-900 dark:text-white">
          TBN/Batch No.&nbsp; {imp&& <span className='text-red-600'>*</span>}</label>
        {err?(<input 
        id='batch'
        name='batch'
        type='text'
        disabled={dont}
  className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-600 focus:border-blue-600 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
       value={value}
       onChange={handleInputChange}/>):(<>
        <select
        value={value}
        disabled={dont}
        onChange={handleInputChange}
        className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-600 focus:border-blue-600 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500">
        <option value="" disabled>---Select---</option>

          {batch.map((batch,index) => (
            <option key={index} value={batch.batch_id}>
              {batch.tbn_no}
            </option>
          ))}
        </select>
        </>)}
        
      </div>
    );
  };
  
  export default BatchDropdown;